<section class="loop-settings" aria-label="Stimuli Presentation & Distribution" [formGroup]="settingsForm">
  <header class="loop-settings__header">
    <div class="loop-settings__heading">
      <h2 class="text__lg fw__600"><span>Stimuli Presentation &amp; Distribution</span></h2>
      <span class="text__sm caption" data-testid="loop-settings-count">{{ configuredCount$() }} stimuli</span>
    </div>
    <button mat-icon-button type="button" aria-label="Close stimulus settings" data-testid="loop-settings-close-button" (click)="onClose()">
      <fa-icon [icon]="faXmark" />
    </button>
  </header>
  <div class="loop-settings__content">
    <div class="loop-settings__randomization">
      <div class="loop-settings__randomization-row">
        <span class="text__sm fw__500">Randomize stimulus order</span>
        <mat-slide-toggle formControlName="randomized" color="primary" aria-label="Randomize stimulus order" data-testid="loop-settings-randomized-toggle" />
      </div>
      <p class="text__sm caption">
        <span>Randomize the order in which selected stimuli are shown to participants. When off, stimuli follow their ID order.</span>
      </p>
    </div>
    <eiq-input
      type="number"
      formControlName="quantity"
      label="Stimuli shown per participant"
      [placeholder]="quantityPlaceholder$()"
      [max]="configuredCount$()"
      descriptionHint="The number of stimuli each participant will evaluate. Leave empty to show all stimuli."
      testId="loop-settings-quantity"
    />
    <eiq-input
      type="number"
      formControlName="completionTarget"
      label="Minimum exposures per stimulus"
      placeholder="e.g. 100"
      descriptionHint="Target priority applies when participants receive a subset of stimuli. Leave quantity empty to show all eligible stimuli, including those already at target."
      testId="loop-settings-target"
    />
  </div>
  <div class="loop-settings__footer"></div>
</section>
